import { render, staticRenderFns } from "./homepage_pc2.vue?vue&type=template&id=346f11ec&"
import script from "./homepage_pc2.vue?vue&type=script&lang=js&"
export * from "./homepage_pc2.vue?vue&type=script&lang=js&"
import style0 from "./homepage_pc2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports